export default __webpack_public_path__ + "static/media/lapetitefaim.0eaec86b.jpg";